document.documentElement.classList.remove('no-js');

document.addEventListener('click', async (event) => {
  const quickAdd = event.target.closest('[data-quick-add]');
  if (quickAdd) {
    quickAdd.disabled = true;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: Number(quickAdd.dataset.variant), quantity: 1}]})
      });
      if (!response.ok) throw new Error('Unable to add item');
      quickAdd.textContent = 'Added';
      setTimeout(() => { window.location.href = '/cart'; }, 500);
    } catch (error) {
      quickAdd.textContent = 'Try again';
      quickAdd.disabled = false;
    }
  }

  const menuToggle = event.target.closest('[data-menu-toggle]');
  if (menuToggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!isOpen));
    menu.hidden = isOpen;
  }

  const thumbnail = event.target.closest('[data-media-target]');
  if (thumbnail) {
    const target = document.getElementById(thumbnail.dataset.mediaTarget);
    if (target) {
      document.querySelectorAll('.product-media-item').forEach((item) => item.classList.remove('is-active'));
      target.classList.add('is-active');
      if (window.innerWidth <= 900) target.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
    }
    document.querySelectorAll('.product-thumbnail').forEach((item) => item.classList.remove('is-active'));
    thumbnail.classList.add('is-active');
  }

  const stickyAdd = event.target.closest('[data-sticky-add]');
  if (stickyAdd) {
    const submit = document.querySelector('[data-product-form] button[type="submit"]');
    if (submit) submit.click();
  }
});

const productForm = document.querySelector('[data-product-form]');
if (productForm) {
  const variantSelect = productForm.querySelector('[data-variant-select]');
  const price = document.querySelector('[data-product-price]');
  if (variantSelect && price) {
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      const comparePrice = option.dataset.comparePrice;
      price.innerHTML = `${comparePrice && comparePrice !== '$0.00' ? `<s>${comparePrice}</s>` : ''}<span>${option.dataset.price}</span>`;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  }

  const stickyBar = document.querySelector('[data-sticky-product-bar]');
  const submitButton = productForm.querySelector('button[type="submit"]');
  if (stickyBar && submitButton && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
    }, {threshold: 0});
    observer.observe(submitButton);
  }
}
